// extracted by mini-css-extract-plugin
export default {"container":"Embed-module__container--Oe8eA","isDocumentLike":"Embed-module__isDocumentLike--FklKy"};